export const sectors = [
  {
    name: 'Industrie manufacturière',
    challenge: 'Volatilité des matières premières et dépendance aux fournisseurs historiques.',
    levers: ['Contrats indexés', 'Double sourcing', 'Analyse du coût complet'],
  },
  {
    name: 'Agroalimentaire',
    challenge: 'Saisonnalité, emballages et exigences de traçabilité.',
    levers: ['Sécurisation emballages', 'Prévisions saisonnières', 'Audits qualité'],
  },
  {
    name: 'Distribution & retail',
    challenge: 'Équilibre entre disponibilité en rayon et niveau de stock.',
    levers: ['Segmentation ABC/XYZ', 'Réassort automatisé', 'S&OP'],
  },
  {
    name: 'Santé & pharmaceutique',
    challenge: 'Exigences réglementaires et continuité d’approvisionnement critique.',
    levers: ['Qualification fournisseurs', 'Stocks de sécurité', 'Plans de continuité'],
  },
  {
    name: 'Énergie & utilities',
    challenge: 'Achats de travaux et de services à fort montant, sur des cycles longs.',
    levers: ['Accords-cadres', 'Pilotage des prestataires', 'Clauses de performance'],
  },
  {
    name: 'BTP & construction',
    challenge: 'Fluctuation des prix des matériaux et multiplicité des chantiers.',
    levers: ['Centralisation des achats', 'Référencement', 'Logistique chantier'],
  },
  {
    name: 'Transport & logistique',
    challenge: 'Coûts de transport, sous-traitance et taux de service.',
    levers: ['Appels d’offres transport', 'Optimisation des flux', 'KPI prestataires'],
  },
  {
    name: 'Services & tertiaire',
    challenge: 'Frais généraux dispersés et faible visibilité sur les dépenses.',
    levers: ['Cartographie des dépenses', 'Procure-to-Pay', 'Contrats-cadres'],
  },
  {
    name: 'Aéronautique & défense',
    challenge: 'Chaînes d’approvisionnement longues et fournisseurs de rang 2 fragiles.',
    levers: ['Gestion des risques', 'Développement fournisseurs', 'Plans de capacité'],
  },
  {
    name: 'Secteur public & associatif',
    challenge: 'Cadre de la commande publique et contraintes budgétaires.',
    levers: ['Rédaction de cahiers des charges', 'Analyse des offres', 'Suivi d’exécution'],
  },
];
